var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{class:[_vm.isAnimated && 'gst-pulse-animation'],attrs:{"text":"","color":"white","placeholder":_vm.placeholder},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }